import { ComponentWithTooltip } from 'components/ComponentWithTooltip';
import { BimActKc2TotalCalcMethodEnum } from 'gql/graphql';
import { IconUser, IconScreenFilled, IconDocFilled, cnMixSpace } from 'uikit';

import type { ICellRendererParams } from 'ag-grid-community';
import type { CSSProperties } from 'react';
import { useMemo } from 'react';

import type { BimActKc2DataExtended } from '../types';

const COMMON_STYLE: CSSProperties = { display: 'flex', alignItems: 'center' };

export const NumberCellRendererComponent = (props: ICellRendererParams<BimActKc2DataExtended>) => {
    const { data } = props;
    const { isActRow, number, calcMethod, isCorrection, fullNumber } = data || {};

    const currentNumber = useMemo(() => (isCorrection ? fullNumber : number), [fullNumber, isCorrection, number]);

    const currentValueIcon = useMemo(() => {
        if (calcMethod === BimActKc2TotalCalcMethodEnum.FromXml) {
            return (
                <ComponentWithTooltip tooltipText="Итоги считаны из файла xml" styles={COMMON_STYLE}>
                    <IconDocFilled size="s" view="success" className={cnMixSpace({ mR: 'xs' })} />
                </ComponentWithTooltip>
            );
        }
        if (calcMethod === BimActKc2TotalCalcMethodEnum.SystemCalculated) {
            return (
                <ComponentWithTooltip tooltipText="Рассчитано системой" styles={COMMON_STYLE}>
                    <IconScreenFilled size="s" view="link" className={cnMixSpace({ mR: 'xs' })} />
                </ComponentWithTooltip>
            );
        }
        if (calcMethod === BimActKc2TotalCalcMethodEnum.UserCorrected) {
            return (
                <ComponentWithTooltip tooltipText="Скорректировано пользователем" styles={COMMON_STYLE}>
                    <IconUser size="s" view="warning" className={cnMixSpace({ mR: 'xs' })} />
                </ComponentWithTooltip>
            );
        }

        return null;
    }, [calcMethod]);

    return isActRow ? (
        <div style={COMMON_STYLE}>
            {currentValueIcon}
            <strong>КС2 №{currentNumber}</strong>
        </div>
    ) : (
        <span>{currentNumber}</span>
    );
};

NumberCellRendererComponent.displayName = 'NumberCellRendererComponent';
